import React, { useState } from "react";
import Header from "./component/layout/Header";
import Footer from "./component/layout/Footer";
import CustomeSignInPopup from "./component/User/Signup/CustomeSignInPopup";
import Popup from "./component/User/Signup/SingupPopup";

const LoginPage = () => {
  const [showSignUpPopup, setShowSignUpPopup] = useState(true);

  const handleSignUpSuccess = () => {
    setShowSignUpPopup(false);
    // Redirect to home page or any other page
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
     <div className=" min-h-screen">
     <Header />

     

{/* Footer */}
<Footer />
     </div>

      {/* Signup Popup */}
      {showSignUpPopup && (
        <Popup onClose={() => setShowSignUpPopup(false)} onSignUpSuccess={handleSignUpSuccess} />
      )}
    </div>
  );
};

export default LoginPage;
